<small class="debug">{{me}}</small>
<!--<mat-label>-->
<!--    <mat-icon style="margin-right: 10px">format_line_spacing</mat-icon>-->
<!--    <span style="position: relative; top: -6px">{{'general.textPosition' | transloco}}</span>-->
<!--</mat-label>-->
<!--<br/>-->
<app-constraint-checker [setModel]="model" (changed)="onChange($event)"></app-constraint-checker>
<br/>
<br/>
<br/>
